import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { PaperPlaneTilt, Clock } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function FlashReports() {
  const [clients, setClients] = useState([]);
  const [previews, setPreviews] = useState({});
  const [running, setRunning] = useState(false);

  const load = async () => {
    const c = await api.get("/clients");
    setClients(c.data);
    const p = {};
    for (const cl of c.data) {
      try { const r = await api.get(`/flash-reports/preview/${cl.id}`); p[cl.id] = r.data; } catch (_) {}
    }
    setPreviews(p);
  };
  useEffect(() => { load(); }, []);

  const runNow = async () => {
    setRunning(true);
    try {
      const r = await api.post("/flash-reports/run");
      toast.success(`Sent ${r.data.count} flash message(s) (simulated WhatsApp)`);
    } finally { setRunning(false); }
  };

  return (
    <div className="space-y-6" data-testid="flash-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500">Automation</div>
          <h1 className="mt-1 font-[Manrope] font-extrabold text-4xl tracking-tight">Daily flash reports</h1>
          <p className="mt-2 text-slate-600 max-w-2xl">A summary of document statuses and recent communications, delivered to every linked contact via WhatsApp.</p>
        </div>
        <Button data-testid="run-flash-btn" onClick={runNow} disabled={running} className="bg-[#0F172A] hover:bg-[#0F172A]/90 text-white">
          <PaperPlaneTilt size={16} className="mr-1.5" weight="fill" /> {running ? "Dispatching…" : "Run now"}
        </Button>
      </div>

      <Card className="border border-slate-200 shadow-none rounded-md p-5 flex items-center gap-3">
        <Clock size={18} className="text-slate-500" />
        <div className="text-sm text-slate-700">Automatic daily dispatch is <span className="font-mono font-semibold text-slate-900">disabled</span>. Reports are sent only when you click <span className="font-semibold">Run now</span>.</div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {clients.length === 0 && <div className="text-sm text-slate-500">Add clients to generate flash reports.</div>}
        {clients.map(cl => {
          const p = previews[cl.id];
          return (
            <Card key={cl.id} className="border border-slate-200 shadow-none rounded-md p-5" data-testid={`flash-preview-${cl.id}`}>
              <div className="font-[Manrope] font-bold text-lg">{cl.name}</div>
              <div className="text-xs font-mono text-slate-500 mt-0.5">{cl.company || "—"}</div>
              {p ? (
                <>
                  <div className="mt-4 grid grid-cols-4 gap-2 text-center">
                    {Object.entries(p.counts).map(([k, v]) => (
                      <div key={k} className="rounded-md border border-slate-200 py-2">
                        <div className="font-[Manrope] font-extrabold text-xl tabular-nums">{v}</div>
                        <div className="text-[10px] uppercase font-mono text-slate-500 tracking-widest">{k.split(" ")[0]}</div>
                      </div>
                    ))}
                  </div>
                  <pre className="mt-4 whitespace-pre-wrap text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-md p-3 font-mono">{p.summary}</pre>
                </>
              ) : <div className="mt-3 text-sm text-slate-500">Loading preview…</div>}
            </Card>
          );
        })}
      </div>
    </div>
  );
}
